export default __webpack_public_path__ + "static/media/infer.d6f32041.png";